import React from "react";
import { Link } from "react-router-dom";
import { GiReceiveMoney } from "react-icons/gi";
import { FaBox } from "react-icons/fa";
import { FaPeopleCarryBox } from "react-icons/fa6";

const HeroMenu: React.FC = () => {
  const IconDonasi = GiReceiveMoney as React.FC<React.SVGProps<SVGSVGElement>>;
  const IconBox = FaPeopleCarryBox as React.FC<React.SVGProps<SVGSVGElement>>;
  return (
    <section className="relative z-30 -mt-16 md:-mt-24 px-3 sm:px-4">
      <div className="max-w-6xl mx-auto grid grid-cols-3 gap-3 sm:gap-4 md:gap-6">
        {/* CARD 1 */}

        <div className="bg-white rounded-2xl sm:rounded-3xl shadow-xl p-3 sm:p-5 md:p-6 text-center transition hover:-translate-y-2">
          <Link to={"/fokus/kebutuhan-dasar"}>
            <img src="/images/daftar.png" alt="Donasi Barang" className="w-10 sm:w-12 md:w-16 mx-auto mb-2 sm:mb-3 md:mb-4" />
          </Link>

          <Link to={"/fokus/kebutuhan-dasar"}>
            <h4 className="text-[10px] md:text-base font-bold hover:text-red-600">
              <span className="block sm:hidden">
                Kebutuhan
                <br />
                Dasar
              </span>
              <span className="hidden sm:inline">Kebutuhan Dasar</span>
            </h4>
          </Link>
        </div>

        {/* CARD 2 */}
        <div className="bg-white rounded-2xl sm:rounded-3xl shadow-xl p-3 sm:p-5 md:p-6 text-center transition hover:-translate-y-2">
          <Link to={"/fokus/produktifitas-pemberdayaan"}>
            <img src="/images/icon1.png" alt="Donasi" className="w-10 sm:w-12 md:w-16 mx-auto mb-2 sm:mb-3 md:mb-4" />
          </Link>
          <Link to={"/fokus/produktifitas-pemberdayaan"}>
            <h4 className="text-[9px] md:text-base font-bold hover:text-red-600">Produktivitas & Pemberdayaan</h4>
          </Link>
        </div>

        {/* CARD 3 */}
        <div className="bg-white rounded-2xl sm:rounded-3xl shadow-xl p-3 sm:p-5 md:p-6 text-center transition hover:-translate-y-2">
          <Link to={"/fokus/akses-layanan"}>
            <img src="/images/icon3.png" alt="Smart Maps" className="w-11 sm:w-12 md:w-16 mx-auto mb-2 sm:mb-3 md:mb-4" />
          </Link>
          <Link to={"/fokus/akses-layanan"}>
            <h4 className="text-[10px] md:text-base font-bold hover:text-red-600">
              <span className="block sm:hidden">
                Akses <br />
                Layanan Dasar
              </span>
              <span className="hidden sm:inline">Akses Layanan Dasar</span>
            </h4>
          </Link>
        </div>
      </div>

      <div className="max-w-6xl mx-auto grid grid-cols-2 sm:grid-cols-2 gap-4 mt-8 max-sm:mt-4">
        {/* Total Pengumpulan */}
        <div className="bg-white rounded-2xl sm:rounded-3xl shadow-xl p-4 sm:p-5 md:p-6 text-center transition hover:-translate-y-2">
          <div className="flex justify-center mb-2 sm:mb-3">
            <IconDonasi className="w-14 h-14 text-red-600" />
          </div>

          <p className="text-xs sm:text-sm font-semibold text-gray-500 mb-1">Total Pengumpulan</p>

          <h4 className="text-sm sm:text-lg md:text-xl font-bold text-red-600">Rp 1.234.543.000</h4>
        </div>

        {/* Total Penyaluran */}
        <div className="bg-white rounded-2xl sm:rounded-3xl shadow-xl p-4 sm:p-5 md:p-6 text-center transition hover:-translate-y-2">
          <div className="flex justify-center mb-2 sm:mb-3">
            <IconBox className="w-14 h-14 text-red-600" />
          </div>

          <p className="text-xs sm:text-sm font-semibold text-gray-500 mb-1">Total Penyaluran</p>

          <h4 className="text-sm sm:text-lg md:text-xl font-bold text-red-600">Rp 835.000.000</h4>
        </div>
      </div>
    </section>
  );
};

export default HeroMenu;
